(function () {
  function getVisibilityRules(root) {
    var script = root.querySelector('[data-caf-visibility]');
    if (!script) return [];
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return [];
    }
  }

  function getSelectedProductTypeLabel(root) {
    var select = root.querySelector('[data-caf-filter="product-type"]');
    if (!select || !select.value) return '';
    var option = select.options[select.selectedIndex];
    return option ? option.getAttribute('data-label') || option.textContent.trim() : '';
  }

  function updateConditionalFields(root, rules) {
    var label = getSelectedProductTypeLabel(root);
    var rule = rules.find(function (r) {
      return r.label === label;
    });
    var showDriver = !!(rule && rule.show_driver_size);
    var showDispersion = !!(rule && rule.show_dispersion);

    var driverField = root.querySelector('[data-caf-conditional="driver-size"]');
    var dispersionField = root.querySelector('[data-caf-conditional="dispersion"]');
    var driverSelect = root.querySelector('[data-caf-filter="driver-size"]');
    var dispersionSelect = root.querySelector('[data-caf-filter="dispersion"]');

    if (driverField) {
      driverField.classList.toggle('is-hidden', !showDriver);
      if (!showDriver && driverSelect) driverSelect.value = '';
    }
    if (dispersionField) {
      dispersionField.classList.toggle('is-hidden', !showDispersion);
      if (!showDispersion && dispersionSelect) dispersionSelect.value = '';
    }
  }

  function collectSelections(root) {
    var selections = [];

    root.querySelectorAll('[data-caf-filter]').forEach(function (select) {
      var field = select.closest('[data-caf-conditional]');
      if (field && field.classList.contains('is-hidden')) return;
      if (!select.value) return;

      var option = select.options[select.selectedIndex];
      var paramName = option.getAttribute('data-param-name') || select.getAttribute('data-param-name');
      if (!paramName) return;

      selections.push({
        paramName: paramName,
        value: select.value
      });
    });

    return selections;
  }

  function navigateWithFilters(root, selections) {
    var base = root.getAttribute('data-collection-url') || window.location.pathname;
    var current = new URLSearchParams(window.location.search);
    var params = new URLSearchParams();

    if (current.has('sort_by')) params.set('sort_by', current.get('sort_by'));
    if (current.has('q')) params.set('q', current.get('q'));
    if (current.has('options[prefix]')) params.set('options[prefix]', current.get('options[prefix]'));

    var filterKeys = {};
    selections.forEach(function (item) {
      if (item.paramName && item.value) {
        filterKeys[item.paramName] = item.value;
      }
    });
    Object.keys(filterKeys).forEach(function (key) {
      params.set(key, filterKeys[key]);
    });

    var qs = params.toString();
    window.location.href = qs ? base + '?' + qs : base;
  }

  function initRoot(root) {
    var rules = getVisibilityRules(root);

    updateConditionalFields(root, rules);

    root.querySelectorAll('[data-caf-filter]').forEach(function (select) {
      select.addEventListener('change', function () {
        if (select.getAttribute('data-caf-filter') === 'product-type') {
          root.querySelector('[data-caf-filter="driver-size"]').value = '';
          root.querySelector('[data-caf-filter="dispersion"]').value = '';
          updateConditionalFields(root, rules);
        }
        navigateWithFilters(root, collectSelections(root));
      });
    });

    var clearBtn = root.querySelector('[data-caf-clear]');
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        root.querySelectorAll('[data-caf-filter]').forEach(function (select) {
          select.value = '';
        });
        updateConditionalFields(root, rules);
        navigateWithFilters(root, []);
      });
    }
  }

  document.querySelectorAll('[data-collection-advanced-filters]').forEach(initRoot);
})();
